import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { useParams, useHistory } from 'react-router-dom';
import type { ManagedProps } from '@ziynx/flow-types/appManager';
import { withAppManager } from '@ziynx/components/utilities';
import { ContentContainer } from '@ziynx/components/layout';
import TalentList from './TalentList';
import RecommendedList from './RecommendedList';
import CompanyList from './CompanyList';

type History = {
  push: (pathName: string, {from: string}) => void,
};

const ContentWrapper = styled.div`
  width: 100%;
`;

const AdminDash = (props: ManagedProps<Props>): React$Node => {
  const { viewport } = props;

  const { tab } = useParams();

  const history: History = useHistory();

  const isMobile = viewport === 'mobile' || viewport === 'mobileSmall';

  let TabContent = null;

  switch (tab) {
  case 'talent':
    TabContent = TalentList;
    break;
  case 'company':
    TabContent = CompanyList;
    break;
  case 'recommended':
    TabContent = RecommendedList;
    break;
  default:
    history.push('/admin/talent');
    break;
  }

  return (
    <>
      <Helmet>
        <title>
          {tab}
          {' '}
          | ZIYNX Admin
        </title>
      </Helmet>
      <ContentContainer offsetTop={isMobile ? 86 : 96}>
        <ContentWrapper>
          <TabContent />
        </ContentWrapper>

      </ContentContainer>
    </>
  );
};

export default (withAppManager(AdminDash): React$ComponentType<ManagedProps<Props>>);
